
import Vue from 'vue'
import { apiService } from '../service/api.service'
import licenceTable from '../components/licences/LicenceTable.vue'
import activationKeys from '../components/licences/ActivationKeys.vue'
import licenceGroups from '../components/licences/LicenceGroups.vue'
import productKeyActivation from '../components/licences/ProductKeyActivation.vue'
import orderNumbers from '../components/licences/OrderNumbers.vue'

export default Vue.extend({
  components: { licenceTable, activationKeys, licenceGroups, productKeyActivation, orderNumbers },
  data () {
    return {
      tab: 0,
      isOnpremise: false,
      modeLoading: true,
      pools: []
    }
  },
  async mounted () {
    try {
      const { data } = await apiService.get('product-key/status')
      this.isOnpremise = data.mode === 'onpremise'
      this.pools = data.pools || []
    } catch {
      this.isOnpremise = false
    } finally {
      this.modeLoading = false
    }
  }
})
